/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_JobsInputs */

const en_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Print Jobs`)
};

const es_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajos de Impresión`)
};

const fr_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travaux d'Impression`)
};

const de_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Druckaufträge`)
};

const ja_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印刷ジョブ`)
};

const zh_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打印任务`)
};

const ar_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهام الطباعة`)
};

const id_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugas Cetak`)
};

const it_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori di Stampa`)
};

const ru_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задачи на Печать`)
};

const pt_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalhos de Impressão`)
};

const ko_print_jobs = /** @type {(inputs: Print_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인쇄 작업`)
};

/**
* | output |
* | --- |
* | "Print Jobs" |
*
* @param {Print_JobsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const print_jobs = /** @type {((inputs?: Print_JobsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_JobsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_print_jobs(inputs)
	if (locale === "es") return es_print_jobs(inputs)
	if (locale === "fr") return fr_print_jobs(inputs)
	if (locale === "de") return de_print_jobs(inputs)
	if (locale === "ja") return ja_print_jobs(inputs)
	if (locale === "zh") return zh_print_jobs(inputs)
	if (locale === "ar") return ar_print_jobs(inputs)
	if (locale === "id") return id_print_jobs(inputs)
	if (locale === "it") return it_print_jobs(inputs)
	if (locale === "ru") return ru_print_jobs(inputs)
	if (locale === "pt") return pt_print_jobs(inputs)
	return ko_print_jobs(inputs)
});